import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";
import Restful from "lib/restful";
import config from "lib/fr-config";
import GaHelper from "lib/gaHelper";

const UNIT_LENGTH = config.outfitList.LENGTH;
const EXP_MINUTE = 30;

const INIT_TARGET_DATA = "itemDetail/INIT_TARGET_DATA";
const SET_ITEM_INFO = "itemDetail/SET_ITEM_INFO";
const SET_MEMO_DATA = "itemDetail/SET_MEMO_DATA";
const SET_CURRENT_ITEM_HASH = "itemDetail/SET_CURRENT_ITEM_HASH";
const SET_IS_LOADING_OF_TARGET = "itemDetail/SET_IS_LOADING_OF_TARGET";
const SET_IS_LOADING_OF_GLOBAL = "itemDetail/SET_IS_LOADING_OF_GLOBAL";
const EXPORT_ITEM_INFO = "itemDetail/EXPORT_ITEM_INFO";
const EXPORT_MEMO_DATA = "itemDetail/EXPORT_MEMO_DATA";
const INIT_EXPORTED_OUTFIT_LIST = "itemDetail/INIT_EXPORTED_OUTFIT_LIST";
const INIT_TARGET_OUTFIT_LIST = "itemDetail/INIT_TARGET_OUTFIT_LIST";
const SET_OUTFIT_LIST = "itemDetail/SET_OUTFIT_LIST";
const CHECK_IS_END = "itemDetail/CHECK_IS_END";
const SET_EXPIRATION_DATE = "itemDetail/SET_EXPIRATION_DATE";
const EXPORT_OUTFIT_LIST = "itemDetail/EXPORT_OUTFIT_LIST";
const INIT_ALL_DATA = "itemDetail/INIT_ALL_DATA";

const initTargetData = createAction(INIT_TARGET_DATA);
const setItemInfo = createAction(SET_ITEM_INFO);
const setMemoData = createAction(SET_MEMO_DATA);
const setCurrentItemHash = createAction(SET_CURRENT_ITEM_HASH);
const setIsLoadingOfTarget = createAction(SET_IS_LOADING_OF_TARGET);
const setIsLoadingOfGlobal = createAction(SET_IS_LOADING_OF_GLOBAL);
const exportItemInfo = createAction(EXPORT_ITEM_INFO);
const exportMemoData = createAction(EXPORT_MEMO_DATA);
const initExportedOutfitList = createAction(INIT_EXPORTED_OUTFIT_LIST);
const initTargetOutfitList = createAction(INIT_TARGET_OUTFIT_LIST);
const setOutfitList = createAction(SET_OUTFIT_LIST);
const checkIsEnd = createAction(CHECK_IS_END);
const setExpirationDate = createAction(SET_EXPIRATION_DATE);
const exportOutfitList = createAction(EXPORT_OUTFIT_LIST);
const initAllData = createAction(INIT_ALL_DATA);

const getItemDetailState = ({ getState }) => {
  const itemDetailState = getState().itemDetail.toJS();
  return itemDetailState;
};

const getTargetData = ({ getState, itemHash }) => {
  const { data } = getItemDetailState({ getState });
  return data[itemHash] || {};
};

const hasTargetDataExist = ({ itemHash, getState }) => {
  const { data } = getItemDetailState({ getState });
  return !!data[itemHash];
};

const getIsLoadingOfTarget = ({ getState, itemHash }) => {
  const { isLoading } = getTargetData({ getState, itemHash });
  return !!isLoading;
};

const setAndExportIsLoading = ({ dispatch, getState, itemHash, isLoading }) => {
  dispatch(setIsLoadingOfTarget({ itemHash, isLoading }));
  exportIsLoading({ dispatch, getState, itemHash });
};

const exportIsLoading = ({ dispatch, getState, itemHash }) => {
  const { itemHash: curItemHash } = getItemDetailState({ getState });
  if (itemHash === curItemHash) {
    const isLoading = getIsLoadingOfTarget({ getState, itemHash });
    dispatch(setIsLoadingOfGlobal(isLoading));
  }
};

const validateInputs = ({ brand, category, /*gender,*/ image, itemHash }) => {
  const nullInput = [];

  if (brand == null) nullInput.push("brand");
  if (category == null) nullInput.push("category");
  // if (gender == null) nullInput.push("gender");
  if (image == null) nullInput.push("image");
  if (itemHash == null) nullInput.push("itemHash");

  if (nullInput.length === 0) {
    return null;
  } else {
    throw Error(`wrong input : ${nullInput.join()}`);
  }
};

const checkExpDate = ({ getState, itemHash }) => {
  const targetData = getTargetData({ getState, itemHash });
  const expirationDate = targetData && targetData.expirationDate;
  if (!expirationDate) return { needUpdate: true };
  const nowDate = new Date();
  return { needUpdate: nowDate > expirationDate ? true : false };
};

const setExpDate = ({ dispatch, itemHash }) => {
  const expirationDate = new Date();
  expirationDate.setMinutes(expirationDate.getMinutes() + EXP_MINUTE);
  dispatch(setExpirationDate({ itemHash, expirationDate }));
};

const getLastHash = list => {
  if (list.length === 0) return undefined;
  const length = list.length;
  return list[length - 1]["outfitHash"];
};

const addNewList = async ({ dispatch, getState, itemHash, idToken }) => {
  const { savedList } = getTargetData({ getState, itemHash });

  const { code, res, errInfo } = await Restful.getOutfitWithItemAPI({
    itemHash,
    lastHash: getLastHash(savedList),
    idToken,
    length: UNIT_LENGTH
  });
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  } else {
    const { list } = res;
    dispatch(setOutfitList({ itemHash, savedList: savedList.concat(list) }));
    dispatch(checkIsEnd({ itemHash, length: list.length }));

    GaHelper.setGARequestOutfitListEvent({
      type: "outfitWithItemList",
      pageNum: savedList.length / UNIT_LENGTH + 1
    });
  }
};

const writeItemInfoAndExport = async ({
  dispatch,
  getState,
  itemHash,
  idToken
}) => {
  const { itemInfo } = getTargetData({ getState, itemHash });

  if (!itemInfo) {
    const { code, res, errInfo } = await Restful.getMyItemInfoAPI({
      itemHash,
      idToken
    });
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
    } else {
      const { info, wrongItemHash } = res;
      dispatch(
        setItemInfo({ ...info, wrongItemHash: wrongItemHash || undefined })
      );
    }
  }

  const { itemHash: curItemHash } = getItemDetailState({ getState });
  if (itemHash === curItemHash) {
    dispatch(exportItemInfo());
  }
};

const exportMemoDataAndRefresh = async ({
  dispatch,
  getState,
  itemHash,
  idToken
}) => {
  if (getItemDetailState({ getState }).itemHash === itemHash) {
    dispatch(exportMemoData());
  }

  const { code, res, errInfo } = await Restful.getItemMemosAPI({
    itemHash,
    idToken
  });
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  } else {
    const { memoData } = res;
    if (memoData) {
      /** 사용자가 소유하지 않은 아이템해시 값 전달시 memoDate 값 null 전달받음 */
      dispatch(setMemoData({ itemHash, memoData }));
    }
  }

  if (getItemDetailState({ getState }).itemHash === itemHash) {
    dispatch(exportMemoData());
  }
};

const writeOutfitListAndExport = async ({
  dispatch,
  getState,
  itemHash,
  idToken
}) => {
  const { needUpdate } = checkExpDate({ getState, itemHash });
  if (needUpdate) {
    dispatch(initExportedOutfitList());
    dispatch(initTargetOutfitList(itemHash));
    try {
      await addNewList({ dispatch, getState, itemHash, idToken });
    } catch (error) {
      throw error;
    }

    setExpDate({ dispatch, itemHash });
  }

  const { itemHash: curItemHash } = getItemDetailState({ getState });
  if (itemHash === curItemHash) {
    dispatch(exportOutfitList());
  }
};

const concatOutfitListAndExport = async ({
  dispatch,
  getState,
  itemHash,
  idToken
}) => {
  const { isEnd } = getTargetData({ getState, itemHash });
  if (isEnd) return null;

  try {
    await addNewList({ dispatch, getState, itemHash, idToken });
  } catch (error) {
    throw error;
  }

  const { itemHash: curItemHash } = getItemDetailState({ getState });
  if (itemHash === curItemHash) {
    dispatch(exportOutfitList());
  }
};

export const initItemInfo =
  ({ brand, category, color, gender, image, itemHash, tag }) =>
  (dispatch, getState) => {
    const inputObj = { brand, category, color, gender, image, itemHash, tag };

    if (hasTargetDataExist({ itemHash, getState })) return null;

    validateInputs(inputObj);

    dispatch(initTargetData(itemHash));
    dispatch(setItemInfo(inputObj));
  };

export const initOutfitListAndItemInfo =
  ({ itemHash, idToken }) =>
  async (dispatch, getState) => {
    dispatch(setCurrentItemHash(itemHash));

    const hasExist = hasTargetDataExist({ itemHash, getState });
    if (!hasExist) {
      dispatch(initTargetData(itemHash));
    }

    const isLoading = getIsLoadingOfTarget({ getState, itemHash });
    if (isLoading) return null;

    setAndExportIsLoading({ dispatch, getState, itemHash, isLoading: true });

    try {
      await Promise.all([
        writeItemInfoAndExport({ dispatch, getState, itemHash, idToken }),
        exportMemoDataAndRefresh({ dispatch, getState, itemHash, idToken }),
        writeOutfitListAndExport({ dispatch, getState, itemHash, idToken })
      ]);
    } catch (error) {
      setAndExportIsLoading({ dispatch, getState, itemHash, isLoading: false });
      throw error;
    }

    setAndExportIsLoading({ dispatch, getState, itemHash, isLoading: false });
  };

export const requestNextList =
  ({ idToken }) =>
  async (dispatch, getState) => {
    const { itemHash } = getItemDetailState({ getState });

    const { isEnd } = getTargetData({ getState, itemHash });
    const isLoading = getIsLoadingOfTarget({ getState, itemHash });
    if (isLoading || isEnd) return null;

    setAndExportIsLoading({ dispatch, getState, itemHash, isLoading: true });

    try {
      await concatOutfitListAndExport({
        dispatch,
        getState,
        itemHash,
        idToken
      });
    } catch (error) {
      setAndExportIsLoading({ dispatch, getState, itemHash, isLoading: false });
      throw error;
    }

    setAndExportIsLoading({ dispatch, getState, itemHash, isLoading: false });
  };

export const writeMemoData =
  ({ itemHash, memoObj, idToken }) =>
  async (dispatch, getState) => {
    const { nickname, place, sizeDetail, memo } = memoObj;

    const { code, res, errInfo } = await Restful.setItemMemosAPI({
      itemHash,
      data: { memoData: { nickname, place, sizeDetail, memo } },
      idToken
    });
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
    } else {
      const { memoData } = res;
      if (memoData) {
        /** 사용자가 소유하지 않은 아이템해시 값 전달시 memoDate 값 null 전달받음 */
        dispatch(setMemoData({ itemHash, memoData }));
      }
    }

    if (getItemDetailState({ getState }).itemHash === itemHash) {
      dispatch(exportMemoData());
    }
  };

export const deleteAllData = () => (dispatch, getState) => {
  dispatch(initAllData());
};

const initialState = fromJS({
  data: {},
  /*
  data 의 구조.
  data: {
    [itemHash]: {
      itemInfo: {}, // { image, itemHash, gender, brand, category, color, tag }
      memoData: {}, // { nickname, place, sizeDetail, memo }
      isLoading: false
      savedList: [],
      expirationDate: null,
      isEnd: false
    }
  },
  */

  itemHash: null,

  itemInfo: null,
  memoData: {},
  outfitList: [],
  isEnd: false,
  isLoading: false
});

export default handleActions(
  {
    [INIT_TARGET_DATA]: (state, action) => {
      const itemHash = action.payload;
      const dataObj = {
        itemInfo: null,
        memoData: {},
        isLoading: false,
        savedList: [],
        expirationDate: null,
        isEnd: false
      };
      return state.setIn(["data", itemHash], fromJS(dataObj));
    },
    [SET_ITEM_INFO]: (state, action) => {
      const itemInfo = action.payload;
      const { itemHash } = itemInfo;
      return state.setIn(["data", itemHash, "itemInfo"], fromJS(itemInfo));
    },
    [SET_MEMO_DATA]: (state, action) => {
      const { itemHash, memoData } = action.payload;
      return state.setIn(["data", itemHash, "memoData"], fromJS(memoData));
    },
    [SET_CURRENT_ITEM_HASH]: (state, action) => {
      const itemHash = action.payload;
      return state.set("itemHash", fromJS(itemHash));
    },
    [SET_IS_LOADING_OF_TARGET]: (state, action) => {
      const { itemHash, isLoading } = action.payload;
      return state.setIn(["data", itemHash, "isLoading"], fromJS(isLoading));
    },
    [SET_IS_LOADING_OF_GLOBAL]: (state, action) => {
      const isLoading = action.payload;
      return state.set("isLoading", fromJS(isLoading));
    },
    [EXPORT_ITEM_INFO]: (state, action) => {
      const { data, itemHash } = state.toJS();
      const { itemInfo } = data[itemHash];
      return state.set("itemInfo", fromJS(itemInfo));
    },
    [EXPORT_MEMO_DATA]: (state, action) => {
      const { data, itemHash } = state.toJS();
      const { memoData } = data[itemHash];
      return state.set("memoData", fromJS(memoData));
    },
    [INIT_EXPORTED_OUTFIT_LIST]: (state, action) => {
      const { outfitList, isEnd } = initialState.toJS();
      return state
        .set("outfitList", fromJS(outfitList))
        .set("isEnd", fromJS(isEnd));
    },
    [INIT_TARGET_OUTFIT_LIST]: (state, action) => {
      const itemHash = action.payload;
      const savedList = [];
      const expirationDate = null;
      const isEnd = false;
      return state
        .setIn(["data", itemHash, "savedList"], fromJS(savedList))
        .setIn(["data", itemHash, "expirationDate"], fromJS(expirationDate))
        .setIn(["data", itemHash, "isEnd"], fromJS(isEnd));
    },
    [SET_OUTFIT_LIST]: (state, action) => {
      const { itemHash, savedList } = action.payload;
      return state.setIn(["data", itemHash, "savedList"], fromJS(savedList));
    },
    [CHECK_IS_END]: (state, action) => {
      const { itemHash, length } = action.payload;
      const isEnd = length === UNIT_LENGTH ? false : true;
      return state.setIn(["data", itemHash, "isEnd"], fromJS(isEnd));
    },
    [SET_EXPIRATION_DATE]: (state, action) => {
      const { itemHash, expirationDate } = action.payload;
      return state.setIn(
        ["data", itemHash, "expirationDate"],
        fromJS(expirationDate)
      );
    },
    [EXPORT_OUTFIT_LIST]: (state, action) => {
      const { data, itemHash } = state.toJS();
      const { savedList, isEnd } = data[itemHash];
      return state
        .set("outfitList", fromJS(savedList))
        .set("isEnd", fromJS(isEnd));
    },
    [INIT_ALL_DATA]: (state, action) => {
      return initialState;
    }
  },
  initialState
);
